import React, { FC } from 'react';
import { Trans } from 'react-i18next';
import { DateTime } from 'luxon';

import Copy from 'Src/components/Copy';
import AuthorizationRequest,
{
  ApprovableEntitlementId,
  AuthorizationRequestFor,
  AuthRequestCheckSurchargeTarget,
  AuthRequestTimeClockOverride,
  AuthRequestUIBlockerMessageLabelKey
} from 'Src/models/AuthorizationRequest';

interface AuthRequestUIBlockerMessageProps {
  data: AuthorizationRequest;
}
const AuthRequestUIBlockerMessage: FC<AuthRequestUIBlockerMessageProps> = ({ data }) => {
  let labelKey = `approvalRequest.uiBlockerHeaders.${data.entitlementId as ApprovableEntitlementId}`;
  let expectedStartTime = undefined as string | undefined;
  let currentTime = undefined as string | undefined;

  switch (data.entitlementId) {
    case 'pos.timeClockOverride.execute':
      if ((data.target as AuthRequestTimeClockOverride).isEarly && (data.target as AuthRequestTimeClockOverride).isScheduled) {
        labelKey = `${labelKey}.early`;
        expectedStartTime = DateTime.fromISO((data.target as AuthRequestTimeClockOverride).expectedStartTime ?? '').toFormat('hh:mm a');
        currentTime = DateTime.fromISO((data.target as AuthRequestTimeClockOverride).currentTime).toFormat('hh:mm a');
      } else if ((data.target as AuthRequestTimeClockOverride).isLate && (data.target as AuthRequestTimeClockOverride).isScheduled) {
        labelKey = `${labelKey}.late`;
        expectedStartTime = DateTime.fromISO((data.target as AuthRequestTimeClockOverride).expectedStartTime ?? '').toFormat('hh:mm a');
        currentTime = DateTime.fromISO((data.target as AuthRequestTimeClockOverride).currentTime).toFormat('hh:mm a');
      } else {
        labelKey = `${labelKey}.unscheduled`;
      }
      break;
    case 'pos.checks.fees.manage':
      labelKey = `${labelKey}.${(data.target as AuthRequestCheckSurchargeTarget).action}`;
      break;
    default:
      break;
  }

  let itemNames = undefined as undefined | string;
  if (data.entitlementId === 'pos.checks.items.void' || data.entitlementId === 'pos.checks.86Items.create') {
    itemNames = (data as AuthorizationRequestFor<typeof data.entitlementId>).target.items.map((i) => i.menuItem.combinedName).join(', ');
  }

  return (
    <Copy variant="body" size="sm">
      <Trans
        i18nKey={labelKey as AuthRequestUIBlockerMessageLabelKey}
        values={{
          target: data.target,
          itemNames,
          expectedStartTime,
          currentTime,
        }}
      />
    </Copy>
  );
};

export default AuthRequestUIBlockerMessage;
